<form [formGroup]="caseChangePriorityForm" class="k-form" *ngIf="caseChangePriorityForm">
  <div class="pl-3 pr-3 pb-3">
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'PRIORITY' | translate}} *
      </span>
      <kendo-combobox class="w-100" formControlName="selectedPriority" required [data]="prioritiesFiltered"
        [textField]="'priorityName'" [valueField]="'priority'" [filterable]="true"
        (filterChange)="casePriorityFilter($event)" [placeholder]="'TYPE-OR-SELECT' | translate">
      </kendo-combobox>
    </label>
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'REASON-FOR-CASE-PRIORITY-CHANGE' | translate}} *
      </span>
      <textarea kendoTextArea [autoSize]="true" class="w-100 k-textarea" rows="2"
        formControlName="reasonForPriorityChanges" maxlength="512"></textarea>
    </label>
  </div>
</form>
<div>* {{'REQUIRED-FIELDS' | translate}}</div>